
<script>

    export default{
        props:[],
        data(){

            return {
                datePickerConfig:{
                    'format':'D/MM/YYYY',
                    'showClose': true
                },
                status:"",
                pedidos: [],
                revendedoras: [],
                revendedora:0,
                fromDate: "",
                toDate: "",
                dateDisabled: {
                    from: new Date()
                },
                enviar: [],
                deletar: 0,
                minimo:0,
                totalItensSelecionados: 0,
                colunas:[
                    ['Revendedora','revendedora'],["Status",'status'],['Criação','created_at'],["Qtd","qtd"],['Valor R$','valor'],
                ],

            }
        },
        methods: {
            initDates: function(){

                let m = moment();

                m.set({hour:0,minute:0,second:0,millisecond:0});

                this.toDate = moment();
                this.toDate.set({hour:0,minute:0,second:0,millisecond:0});

                this.fromDate = m;
                this.fromDate.subtract(1,'month');

            },
            loadingPedidos: function(){
                var vm = this;
                $('.loading').show();
                this.status = 'ABERTO'
                let data = {
                    status: this.status
                };

                axios.get('/distribuidor/pedidos/list',{
                    params: data
                }).then(function(response){

                    vm.pedidos = response.data;

                    $('.loading').hide();
                }).catch(function(error){
                    console.log(error);
                    $('.loading').hide();
                    //alert(error.response.data.errors.join('\n'));
                    vm.$swal('Ops', error.response.data.errors, 'error');
                });
            },

            loadingRevendedoras: function(){

                var vm = this;
                $('.loading').show();

                axios.get('/distribuidor/revendedora/listar').then(function(response){

                    vm.revendedoras = response.data;

                    $('.loading').hide();
                }).catch(function(error){
                    alert(error.response.data.join('\n')).
                    console.log(error);
                    $('.loading').hide();
                });


            },
            changeData: function(){
                this.loadingPedidos();

            },
            computeTotalItens: function(itens){

                var total = 0;

                itens.forEach(function(item){
                    total += parseInt(item.quantidade);
                });

                return total;
            },
            computeValorTotal: function(itens){
                var total = 0;

                itens.forEach(function(item){
                    if(typeof(item.produto.campanhas[0]) !== 'undefined'){
                        let preco = item.produto.campanhas[0].pivot.preco;
                        total += parseInt(item.quantidade - item.estoque) * preco;
                    }


                });

                return total.toFixed(2).replace('.',',');
            },
            computTotalEstoque: function(itens){
                var total = 0;

                itens.forEach(function(item){
                    total += parseInt(item.estoque);
                });

                return total;
            },
            enviarPedido: function(){

                if(this.enviar.length === 0){
                    //alert("Selecione um ou mais pedidos.");
                    this.$swal('Ops', "Selecione um ou mais pedidos.", 'error');
                    return;
                }

                if(this.minimo > 0){
                    if(this.enviar.length < this.minimo){
                        this.$swal('OPs','Favor enviar no mínimo '+ this.minimo + ' pedidos.','error')
                        return;
                    }
                }

                this.marcarTodos = false;
                $(".loading").show();
                var vm = this;

                axios.post('/distribuidor/relatorio/postpedidos',{
                    data: this.enviar,
                    responseType: 'blob'
                }).then(function(response){
                    //console.log(response.data);
                    let blob = new Blob([response.data], { type: 'application/pdf' }),
                    url = window.URL.createObjectURL(blob)
                    window.open(url)

                    $('.loading').hide();
                }).catch(function(error){
                    console.log(error);
                    $('.loading').hide();
                    vm.$swal('Ops', error.response.data.errors, 'error');
                });

            },

            showModalDeletados: function(id){
                this.deletar = id;
                $("#modalDeletado").modal();
            },
            deletarPedido: function(id){
                this.deletar = id;
                $("#modalDeletar").modal();
            },
            comfirmaDelete: function(){
                if(this.enviar.length == 0){
                    flash('Selecione ao menos um pedido, para deletar.','error');
                    console.log('erro .. nenhum pedido selecionado.')
                    return;
                }
                $('.loading').show();
                this.enviar.forEach(function(a){

                    axios.get('/distribuidor/pedidos/'+ a +'/deletar').then(function(response){

                        $('.loading').hide();

                    }).catch(function(error){
                        //alert(error.response.data.errors.join('\n'));
                        vm.$swal('Ops',response.data.errors.join('\n'), 'error');
                        console.log(error);
                        $('.loading').hide();
                    });

                });
                window.location.href = "/distribuidor/pedidos/?status=ABERTO";
            },

            changeMarcarTodos: function(check){


                if(!check){
                    this.enviar = [];
                    this.totalItensSelecionados = 0;
                    return;
                }

                var vm = this;
                this.pedidos.forEach(function(pedido){
                    if(check && pedido.status === "ABERTO" && vm.enviar.indexOf(pedido.id) < 0){

                        vm.addQtdItensSelecionados(pedido.itens);
                        vm.enviar.push(pedido.id);
                    }
                });
            },
            changeQtdItensSelecionados: function(checked,id){

                let pedido = this.getPedidoByID(id);
                let index = this.enviar.indexOf(id);
                if(checked){

                    if( index === -1){
                        this.enviar.push(id);
                    }

                    this.addQtdItensSelecionados(pedido.itens);
                }else{

                    if(index > -1){
                        this.enviar.splice(index,1);
                    }
                    this.removeQtdItensSelecionados(pedido.itens);
                }


            },
            addQtdItensSelecionados: function(itens){
                this.totalItensSelecionados += this.computeTotalItens(itens) - this.computTotalEstoque(itens);
            },
            removeQtdItensSelecionados: function(itens){
                this.totalItensSelecionados -= this.computeTotalItens(itens) - this.computTotalEstoque(itens);
            },
            changeSortOrder: function(coluna){
                this.sortOrder = (this.sortOrder === "ASC")? "DESC" : "ASC";
                this.sortedColunm = coluna;
            },
            getPedidoByID: function(id){

                var pedidoByID = null;

                this.pedidos.forEach(function(pedido,index){
                    if(id === pedido.id){
                        pedidoByID = pedido;
                        return;
                    }
                });
                return pedidoByID;
            },
            showPedido: function(id){
                window.open('/distribuidor/pedidos/'+id+'/detalhar','_blank');
            },
            editPedido: function(id){
                let pedido = this.getPedidoByID(id);

                if(pedido.status == "ENVIADO" || pedido.status == "DELETADO"){
                    //alert("PEDIDO NÂO PODE SER EDITADO");
                    vm.$swal('Ops','Este pedido não pode ser editado', 'error');
                    return;
                }

                window.location.href = '/distribuidor/pedidos/'+id+'/edit';
            }
        },
        computed:{
            'dataTable': function(){
                var data = [];
                var vm = this;
                this.pedidos.forEach(function(pedido,index){
                    let row = {
                        id: pedido.id,
                        revendedora: pedido.revendedora.nome,
                        status: pedido.status,
                        created_at: new Date(pedido.created_at).toLocaleString(),
                        qtd: vm.computeTotalItens(pedido.itens),
                        valor: vm.computeValorTotal(pedido.itens),
                        selectable: pedido.status == 'ABERTO'


                    };
                    data.push(row);
                });
                return data;
            },
            'computedStatus':function(){

                if(this.status == ''){
                    return "TODOS";
                }else{
                    return this.status;
                }
            },
            'isOrderASC':function(){
                if(this.sortOrder === 'ASC'){
                    return true;
                }
                return false;
            },
            actionsTable: function(){

                let actions = ['edit','show'];
                if( this.status === '' || this.status === 'TODOS'){
                    actions = ['edit','show','select','recover'];
                }if( this.status === 'ABERTO'){
                    actions.push('select');
                }else if(this.status === "DELETADO"){
                    actions = ['show','recover'];
                }else if(this.status === "ENVIADO"){
                    actions = ['show']
                }

                return actions;
            }
        },
        created: function(){

            this.status = $("#status").val();
        },
        mounted:function(){

            this.loadingPedidos();
            //this.loadingRevendedoras();
        }
    }

</script>

<template>

    <div class="row">

        <div class="col-md-12">

            <p class="text-right" v-if="status === '' || status ==='ABERTO' ">

                <a href="#" class="btn btn-outline btn-group" @click="enviarPedido"><i class="fas fa-chart-bar"></i> Gerar Relatóri</a>

            </p>

        </div>

        <div class="col-md-12">

            <p v-if="totalItensSelecionados > 0" class="text-left" style="margin-bottom: 0px;">
                <strong class="text-primary">Pedidos Selecionados: </strong>{{enviar.length}}
                <strong class="text-primary"> | </strong>
                <strong class="text-primary">Itens Selecionados: </strong>{{totalItensSelecionados}}
            </p>

            <v-table :column="colunas" :data="dataTable"  :actions="actionsTable" @change="changeQtdItensSelecionados" @markAll="changeMarcarTodos" @show="showPedido" @edit="editPedido" ></v-table>

        </div>

    </div>

</template>

<style scoped="">
    .label-status{
        font-size: 1.2em;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/distribuidor/relatorio/Pedidos.vue